import { QConfigPublishValidationErrorCode } from './constants';

export function getDisabledLOSList(
  errors?: { code: string; value?: Record<string, unknown>[] | undefined }[],
) {
  const losError = errors?.find(
    (error) =>
      error.code === QConfigPublishValidationErrorCode.DISABLED_LEARNING_OBJECTIVE_STATEMENTS_FOUND,
  ) as { value: { id: string; name: string | null }[] } | undefined;

  const rawValue = (losError as { value: { id: string; name: string | null }[] })?.value;
  return Array.isArray(rawValue) ? rawValue : [];
}
